<template>
  <div class="home">

    <WorkCover>
      <template slot="cover">
        <img class="bg-cover" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/thumbs%2FAlgo_mock.jpg?alt=media&token=dd887e6b-5e11-4d74-94ea-a2d72cb73de7" alt="">
      </template>
    </WorkCover>

    <WorkHeader>
      <template slot="year">2022</template>
      <template slot="client">Self-initiated</template>
      <template slot="type">
        <div>
          <div>Concept</div>
          <div>Brand Design</div>
          <div>Digital Design</div>
          <div>Programming</div>
        </div>
      </template>
      <template slot="website">
        <a href="https://algorhythm.world" target="_blank">https://algorhythm.world</a>
      </template>
      <template slot="desc">
          Algorhythm is a music exploration platform designed to attract and determine the best independent music and musicians in your local neighborhood, in your city, in your country and on planet earth.
          <br><br>
          Algorhythm is independently and solely created by MESH.
      </template>
    </WorkHeader>

    <WorkAlgorhythm/>

    <Index/>

    <Footer/>

  </div>
</template>

<script>
import WorkCover from '@/components/work/WorkCover.vue'
import WorkHeader from '@/components/work/WorkHeader.vue'
import WorkAlgorhythm from '@/components/work/WorkAlgorhythm.vue'
import LogoAni from '@/components/LogoAni.vue'
import Slideshow from '@/components/Slideshow.vue'
import Index from '@/components/Index.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'Algorhythm',
  components: {
    WorkHeader,
    WorkCover,
    LogoAni,
    Slideshow,
    Index,
    Footer,
    WorkAlgorhythm
  }
}
</script>
<style scoped lang="scss">
@import "@/scss/_vars.scss";
@import "@/scss/_mixins.scss";
@import "@/scss/_classes.scss";

</style>
